import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { SpaceKey } from "popopo-msg"
import { api } from "../../core"
import { UploadToFireStorageInput } from "../UploadToFireStorageInput"
import { useToast } from "popopo-lib-front/hook"
import { FirebaseStoragePaths } from "popopo-msg"

type MessageCreateForms = {
  kind: "image" | "video" | "text"
  value: string
}

export const SpaceMessageCreateForm = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const { spaceKey } = props
  const form = useForm<MessageCreateForms>({
    mode: "onBlur",
    defaultValues: {
      value: "",
    },
  })
  const toast = useToast()
  const { isSubmitting } = form.formState

  const onSubmit = async (value: MessageCreateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST(`/api/v2/spaces/{space_key}/messages`, {
        params: { path: { space_key: spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: { ...value },
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "メッセージ送信", message: JSON.stringify(res.error) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "メッセージ送信", message: e.message })
      throw e
    }
  }

  const kind = form.watch("kind")

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100" onSubmit={form.handleSubmit(onSubmit)}>
        <select className="form-select" disabled={isSubmitting} {...form.register("kind")}>
          <option value="image">Image</option>
          <option value="video">Video</option>
          <option value="text">Text</option>
        </select>

        <div className="form-floating">
          {kind === "text" ? (
            <>
              <input className="form-control" {...form.register("value")} disabled={isSubmitting} />
              <label>Message</label>
            </>
          ) : (
            <UploadToFireStorageInput
              label="File"
              uploadPath={`/${FirebaseStoragePaths.SpaceMessage.getPathUploaded(props.firebase.uid, spaceKey, kind)}`}
              onChange={(successfullyUploaded) => {
                if (!successfullyUploaded) {
                  form.setError("value", { message: "ファイルが指定されていません。" })
                }
              }}
              disabled={isSubmitting} />
          )}
        </div>

        <button className="btn btn-primary form-control">Send message</button>
      </form>
    </>
  )
}
